import React, { useState } from "react";
import cx from "clsx";
import Tooltip from "react-tooltip";
import { useSunbitWallet } from "./hooks/useSunbitWallet";
import SunbitEnrollModal from "./components/SunbitEnrollModal";
import { formatCurrency } from "../../../../../utilities/general";
import classes from "./scss/ClientWalletSunbit.module.scss";

const ClientWalletSunbit = ({ clientId, clientPhoneNumber }) => {
  const [showModal, setShowModal] = useState(false);
  const { data } = useSunbitWallet(clientId);

  return (
    <>
      <tr className="table-updated-tr sunbit">
        <td className="col-xs-5 table-updated-td bold">
          Sunbit
          <br />
          <div data-tip data-for="manufacturedRewards" className="m-b-2">
            <span className={classes.disclaimer}>
              <strong>Disclaimer: </strong>
              <i className="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <Tooltip id="manufacturedRewards" aria-haspopup="true">
            {`The prequalification amount displayed may not reflect the patient's
            available spending capacity. If the patient has an existing loan
            with Sunbit, their eligibility may have changed.`}
          </Tooltip>
        </td>
        <td className="col-xs-2 table-updated-td text-right"></td>
        <td className="col-xs-2 table-updated-td text-right">
          {data?.payload?.approvalAmount && data?.isEnrolled
            ? formatCurrency(data.payload.approvalAmount)
            : ""}
        </td>
        <td className="col-xs-3 table-updated-td text-center">
          {!data?.isEnrolled && (
            <button
              className={cx("easy-link", classes.prequalifyButton)}
              onClick={() => setShowModal(true)}
            >
              Send Pre-qualification
            </button>
          )}
        </td>
      </tr>
      {showModal && (
        <SunbitEnrollModal
          clientId={clientId}
          onClose={() => setShowModal(false)}
          clientPhoneNumber={clientPhoneNumber}
        />
      )}
    </>
  );
};

export default ClientWalletSunbit;
